import request from '@/libs/request'

//加工商 列表
export function processingCompanyListApi (data) {
  return request({
    url: `plant/processingCompany`,
    method: 'get',
    params: data
  })
}

//加工商 详情
export function processingCompanyInfoApi (id) {
  return request({
    url: `plant/processingCompany/` + id,
    method: 'get'
  })
}


//加工商 编辑/添加
export function processingCompanySaveApi (data) {
  return request({
    url: `plant/processingCompany`,
    method: 'post',
    data: data
  })
}

//加工商 删除
export function processingCompanyDelApi (id) {
  return request({
    url: `plant/processingCompany/` + id,
    method: 'delete'
  })
}

//加工商 所有数据
export function processingCompanyAllApi (data = {}) {
  return request({
    url: `plant/processingCompanyApi/all`,
    method: 'get',
    params: data
  })
}

